export default __webpack_public_path__ + "static/media/logo_helpline.533148fe.jpg";